import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import MovingTips from "../pages/moving-tips/page";
import ArticlePage from "../pages/moving-tips/article/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/moving-tips",
    element: <MovingTips />,
  },
  {
    path: "/moving-tips/article",
    element: <ArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;